/**
 * Location Management Constants
 */

// View modes available in Location Management
export const VIEW_MODES = {
  TREE: 'tree',
  FLAT_LIST: 'flat_list',
  CARD_GRID: 'card_grid',
  BREADCRUMB_DRILL: 'breadcrumb_drill',
  NETWORK: 'network'
};

export const VIEW_MODE_OPTIONS = [
  { value: VIEW_MODES.TREE, label: 'Tree View', icon: 'AccountTree' },
  { value: VIEW_MODES.FLAT_LIST, label: 'List View', icon: 'ViewList' },
  { value: VIEW_MODES.CARD_GRID, label: 'Card View', icon: 'ViewModule' },
  { value: VIEW_MODES.BREADCRUMB_DRILL, label: 'Browse', icon: 'FolderOpen' },
  { value: VIEW_MODES.NETWORK, label: 'Network View', icon: 'Hub' }
];

export const DEFAULT_VIEW_MODE = VIEW_MODES.FLAT_LIST;
export const DEFAULT_ROWS_PER_PAGE = 25;

// Location type configurations with colors and icons
// Type IDs from @caro/shared/constants/domain.ts
export const LOCATION_TYPE_CONFIG = {
  1: { name: 'Site', color: '#1976d2', icon: 'Business' },
  2: { name: 'Building', color: '#388e3c', icon: 'Apartment' },
  3: { name: 'Floor', color: '#f57c00', icon: 'Layers' },
  4: { name: 'Unit', color: '#7b1fa2', icon: 'MeetingRoom' },
  5: { name: 'Room', color: '#c62828', icon: 'Room' },
  6: { name: 'Zone', color: '#00838f', icon: 'GridView' },
  7: { name: 'Hallway', color: '#4e342e', icon: 'LinearScale' },
  8: { name: 'Common Area', color: '#558b2f', icon: 'Groups' },
  9: { name: 'Garden', color: '#2e7d32', icon: 'Park' },
  10: { name: 'Parking', color: '#546e7a', icon: 'LocalParking' },
  11: { name: 'Storage', color: '#795548', icon: 'Warehouse' },
  12: { name: 'Technical Room', color: '#455a64', icon: 'Construction' },
  13: { name: 'Office', color: '#1565c0', icon: 'Work' },
  14: { name: 'Kitchen', color: '#e65100', icon: 'Kitchen' },
  15: { name: 'Bathroom', color: '#0277bd', icon: 'Bathroom' },
  16: { name: 'Entrance', color: '#6a1b9a', icon: 'DoorFront' },
  17: { name: 'Staircase', color: '#4527a0', icon: 'Stairs' },
  18: { name: 'Elevator', color: '#283593', icon: 'Elevator' }
};

// Get config for a location type, with fallback
export const getLocationTypeConfig = (typeId) => {
  const id = typeof typeId === 'object' ? (typeId?.id || typeId?.value) : typeId;
  return LOCATION_TYPE_CONFIG[id] || { name: 'Unknown', color: '#9e9e9e', icon: 'LocationOn' };
};

// Sort options for flat list view
export const SORT_OPTIONS = [
  { value: 'friendlyName', label: 'Name' },
  { value: 'locationType', label: 'Type' },
  { value: 'parentName', label: 'Parent' },
  { value: 'deviceCount', label: 'Device Count' },
  { value: 'createdAt', label: 'Created Date' }
];

// Shared detail panel layout constants
export const DETAIL_PANEL_SX = {
  width: '45%',
  maxWidth: 550,
  borderLeft: 1,
  borderColor: 'divider',
  overflowY: 'auto'
};

// Shared mobile drawer paper props
export const MOBILE_DRAWER_PAPER_SX = {
  maxHeight: '90vh',
  borderRadius: '16px 16px 0 0',
  // Drag handle indicator
  '&::before': {
    content: '""',
    display: 'block',
    width: 40,
    height: 4,
    bgcolor: 'divider',
    borderRadius: 2,
    mx: 'auto',
    mt: 1.5,
    mb: 0.5
  }
};

// Quick filter presets for flat list
export const QUICK_FILTER_PRESETS = [
  { label: 'Rooms Only', filter: { typeId: 5 } },
  { label: 'Units Only', filter: { typeId: 4 } },
  { label: 'Buildings', filter: { typeId: 2 } },
  { label: 'Floors', filter: { typeId: 3 } }
];
